import React, {MouseEvent, useCallback, useState} from 'react';
import cn from 'classnames';

import {ITariff} from 'entities/tariff';

import TariffMenu from '../TariffMenu';
import TariffModal from '../TariffModal';

import TariffBadges from './TariffBadges/TariffBadges';
import TariffFeatures from './TariffFeatures/TariffFeatures';
import TariffLimits from './TariffLimits/TariffLimits';
import {
    MONITORING_LIMITS,
    NOTIFICATION_LIMITS,
    REPORT_LIMITS,
    STATUS_PAGE_LIMITS,
} from './TariffLimits/limitChips';

import styles from './TariffRow.module.scss';

interface ITariffRowProps {
    item: ITariff,
}

const TariffRow: React.FC<ITariffRowProps> = ({item}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleClose = useCallback(() => setIsModalOpen(false), []);

    const onEditClick = useCallback((event: MouseEvent) => {
        event.stopPropagation();
        setIsModalOpen(true);
    }, []);

    const onTdClick = useCallback((event: MouseEvent<HTMLTableDataCellElement>) => {
        event.stopPropagation();
    }, []);

    return (
        <>
            <tr className="clickable" onClick={onEditClick}>
                <td className={styles.nameCell}>
                    <div className={styles.name}>{item.name}</div>
                    <TariffBadges item={item}/>
                </td>
                <td className={styles.priceCell}>
                    <div className={styles.price}>{item.price > 0 ? `${item.price} руб` : 'Бесплатный'}</div>
                    <div className={styles.period}>{item.period > 0 ? `${item.period} дн.` : 'бессрочный'}</div>
                </td>
                <td className={styles.limitsCell}>
                    <TariffLimits item={item} chips={MONITORING_LIMITS}/>
                </td>
                <td className={styles.limitsCell}>
                    <TariffLimits item={item} chips={STATUS_PAGE_LIMITS}/>
                    <TariffLimits item={item} chips={REPORT_LIMITS} className={styles.limitsNextRow}/>
                </td>
                <td className={styles.featuresCell}>
                    <TariffFeatures item={item}/>
                </td>
                <td className={styles.limitsCell}>
                    <TariffLimits item={item} chips={NOTIFICATION_LIMITS}/>
                </td>
                <td onClick={onTdClick}>
                    <div className={cn('d-flex', 'justify-content-center')}>
                        <TariffMenu item={item} onEditClick={onEditClick}/>
                    </div>
                </td>
            </tr>
            <TariffModal open={isModalOpen} handleClose={handleClose} item={item}/>
        </>
    );
};

export default React.memo(TariffRow);
